import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ld-wifi",
  "use": "icon-ld-wifi-usage",
  "viewBox": "0 0 9000 7920",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 9000 7920\" id=\"icon-ld-wifi\">\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol